module.exports = __webpack_public_path__ + "static/img/quan01.d7eba92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quan01.png
// module id = DAF+
// module chunks = 0